import * as React from "react";
import { Account, AccountNextStep, Person } from "@/types";
import { cleanedErrors } from "@/utils/Functions";
import {
  PersonBankAccount as BankAccountRecord,
} from "../BankAccountDetailsFields";
import {
  errorsOfFinalBalanceManager,
  FinalBalanceManagerFields,
} from "./FinalBalanceManagerFields";
import { errorsOfNewAccountHolder, NewAccountHolderFields } from "./NewAccountHolderFields";
import { NestedErrors } from "@/utils/Types";

export type Responsible = {
  readonly responsibleId?: string;
  readonly responsible?: Person;
  readonly responsibleBankAccount?: BankAccountRecord;
};

export type ResponsibleErrors = NestedErrors<Responsible> | undefined

export function errorsOfResponsible(record: undefined | Responsible, accountRequest: AccountNextStep | undefined): ResponsibleErrors {
  return cleanedErrors(
    accountRequest === AccountNextStep.RequestAccountBalance ||
      accountRequest === AccountNextStep.UpdateAccountHolder
      ? errorsOfNewAccountHolder(record)
      : accountRequest === AccountNextStep.Cancel
        ? errorsOfFinalBalanceManager(record)
        : undefined
  );
};

export const responsibleFromAccount = (account: Account | undefined): Responsible => {
  if (!account) return {};


  return { responsibleId: account.responsibleId };
};

type ResponsibleFormProps = {
  readonly serviceProvider: { customForm?: string };
  readonly persons: ReadonlyArray<Person>;
  readonly labelOverride?: string;
  readonly nextStep?: AccountNextStep;
  readonly record: Responsible;
  readonly errors: ResponsibleErrors;
  readonly update: any;
};

export const ResponsibleForm: React.FC<ResponsibleFormProps> = ({
  serviceProvider,
  persons,
  labelOverride,
  nextStep,
  record,
  errors,
  update,
}) => {
  if (nextStep === AccountNextStep.RequestAccountBalance) {
    return (
      <NewAccountHolderFields
        serviceProvider={serviceProvider}
        persons={persons}
        labelOverride={labelOverride ?? "Who will be responsible for the account?"}
        record={record}
        errors={errors}
        update={update}
      />
    );
  }

  if (nextStep === AccountNextStep.UpdateAccountHolder || nextStep === AccountNextStep.MoveToPayAsYouGo) {
    return (
      <NewAccountHolderFields
        serviceProvider={serviceProvider}
        persons={persons}
        labelOverride={labelOverride}
        record={record}
        errors={errors}
        update={update}
      />
    );
  }

  if (nextStep === AccountNextStep.Cancel || nextStep === AccountNextStep.MoveToAnotherService) {
    return (
      <FinalBalanceManagerFields
        serviceProvider={serviceProvider}
        persons={persons}
        labelOverride={labelOverride}
        record={record}
        errors={errors}
        update={update}
      />
    );
  }

  return null;
};
